// Loads the PUBLISHABLE billboard contract served at /assets/billboards.json
// (produced by packages/experts `flows/web-export.ts`). Drives the wall
// billboards + Help "Temas" tab.
//
// NOTE: this contract contains NO individual expert positions/quotes/names —
// only topic labels, safe aggregates, and curator-authored `headline`/`body`.

export interface BoardTopic {
  id: string;
  title: string;
  emoji?: string;
  expertCount?: number;
  questionsAnswered?: number;
  meanAgreement?: number | null;
  headline?: string; // short, publishable line for the wall
  body?: string; // longer publishable text for the Help page
}

// Roster entry for the "Expertos consultados" wall. A plain string (legacy,
// name only) or an object with a publishable bio. NEVER tied to a position.
export interface BoardExpert {
  name: string;
  description?: string;
}

export interface Board {
  generatedAt?: string;
  methodology: { title: string; body: string[] };
  topics: BoardTopic[];
  // Roster of experts consulted — NAMES (+ optional bio), never tied to
  // positions. Cleared for publication by the experts team; optional until
  // supplied.
  expertCount?: number; // total distinct experts consulted
  experts?: (string | BoardExpert)[]; // "Expertos consultados" wall + Help tab
}

const EMPTY: Board = {
  methodology: { title: "Metodología", body: [] },
  topics: [],
};

export async function loadBoard(): Promise<Board> {
  try {
    const res = await fetch("/assets/billboards.json");
    if (!res.ok) return EMPTY;
    return (await res.json()) as Board;
  } catch {
    return EMPTY; // forum still works without the expert content
  }
}
